export const NAMESPACE = 'PriceSection';

/**
 * ACTIONS
 */
export const GO_TO_BASKET = `${NAMESPACE}/goToBasket`;
